import { forwardRef, useContext, useImperativeHandle, useRef, useState } from 'react';
import styles from './InvoiceProducts.module.scss';
import { Form, FormSpy } from 'react-final-form';
import { DisbursementFormContext } from '../context/DisbursementFormContext';
import AsyncSelectField from '../AsyncSelectField/AsyncSelectField';
import MeritoButton from '../../../components/common/MeritoButtons/MeritoButtons';
import { RiAddFill as AddIcon } from 'react-icons/ri'
import NewProductForm from '../NewProduct/NewProductForm';
import { FieldArray } from 'react-final-form-arrays';
import { PiShoppingBagOpenDuotone as ShoppingBagIcon } from "react-icons/pi"
import InvoiceProductItem from './InvoiceProductItem';
import arrayMutators from 'final-form-arrays'
import createDecorator from 'final-form-calculate';
import { OnChange } from 'react-final-form-listeners';
import { DisbursementFormSteps } from '../../../interfaces/interfaces';
import { findFirstErrorField } from '../../../components/functions/utilities';

const calculator = createDecorator(
    {
        field: 'invoiceProducts',
        updates: {
            totalAmount: (currVal, allValues: any) => {
                // console.log('invoiceProducts', invoiceProducts);
                let totalAmount = 0;
                const invoiceProducts = allValues?.invoiceProducts ?? [];
                invoiceProducts.forEach((product) => {
                    totalAmount += isNaN(Number(product?.amount)) ? 0 : Number(product?.amount);
                })
                return totalAmount;
            }
        }
    }
)

type Props = {
    ipConfigs: { [x: string]: any },
    setTotalAmount: (value: number) => void;
}

const InvoiceProducts = forwardRef(({ ipConfigs, setTotalAmount }: Props, ref) => {
    const { formData, formStepsValidity, isBtnEnabled, setIsBtnEnabled, formPristine, setFormPristine, setStepValidity } = useContext(DisbursementFormContext);
    const formRef = useRef(null);
    const [isNewProductForm, setIsNewProductForm] = useState(false);

    const manipulateSelectOptions = (onChange, mutators, selectedOption, actionType, allOptions) => {
        console.log('selectedOption', selectedOption, 'actionType', actionType)
        let existingOptions = allOptions ? [...allOptions] : [];
        if (actionType == 'select-option') {
            // const selectedOptionIndex = existingOptions.findIndex((option) => option.value == selectedOption.value);
            existingOptions = [{ ...selectedOption, isNew: false }, ...existingOptions];
            onChange('invoiceProducts', existingOptions)
        } else if (actionType == 'deselect-option') {
            console.log('existing option', existingOptions);
            const selectedOptionIndex = existingOptions.findIndex((option) => option.productId == selectedOption.productId);
            if (selectedOptionIndex != -1) {
                // existingOptions.splice(selectedOptionIndex, 1);
                mutators.remove('invoiceProducts', selectedOptionIndex)
            }
        }
        // console.log('existingOptions', existingOptions)
        // onChange('invoiceProducts', existingOptions);
    }

    const handleAddNewProduct = (onChange, valueToInsert, allOptions) => {
        let existingOptions = allOptions ? [...allOptions] : [];
        existingOptions = [valueToInsert, ...existingOptions];
        onChange('invoiceProducts', existingOptions);
    }

    useImperativeHandle(ref, () => ({
        submitForm: () => {
            return new Promise((resolve) => {
                formRef.current.submit();
                // console.log("pristing", formRef?.current)
                if (!formStepsValidity[DisbursementFormSteps.INVOICE_PRODUCTS]) {
                    scrollToFirstError();
                    resolve({ success: false, values: null, pristine: formRef?.current?.getState().pristine })
                } else {
                    resolve({ success: true, values: formRef?.current?.getState().values, pristine: formRef?.current?.getState().pristine })
                }
            })
        }
    }), [formStepsValidity]);

    const scrollToFirstError = () => {
        try {

            const formState = formRef.current.getState();
            const { errors } = formState;
            console.log('errors', errors);
            // console.log('form state', formState);
            // console.log('formState', formState)
            const firstErrorField = findFirstErrorField(errors);
            // console.log('firstErrorField', firstErrorField);
            const errorField = document.querySelector(`[name="${firstErrorField}"]`);
            // console.log('errorField', errorField);
            if (errorField) {
                errorField.scrollIntoView({ behavior: 'smooth' });
            }
        } catch (error) {
            console.log('error', error)
        }
    };


    return (

        <div className={styles.rootContainer}>
            <Form
                initialValues={formData}
                onSubmit={(values) => {
                    return {};
                }}
                mutators={{
                    ...arrayMutators
                }}
                validate={(values) => {
                    let errors = {} as any;
                    if (!values.invoiceProducts?.length) {
                        errors.invoiceProducts = 'Add at least one product';
                    } else if (Number(values?.totalAmount) != Number(formData?.invoiceDetails?.invoiceAmount)) {
                        errors.totalAmount = 'Amount not matching'
                    }
                    return errors;
                }}
                decorators={[calculator]}
                render={({ values: formValues, form, handleSubmit }) => {
                    // console.log('formValues', formValues)
                    formRef.current = form;
                    // if (formValues?.invoiceProducts?.length) {
                    //     if (!isBtnEnabled) {
                    //         setIsBtnEnabled(true);
                    //     }
                    // } else {
                    //     if (isBtnEnabled) {
                    //         setIsBtnEnabled(false);
                    //     }
                    // }
                    return (
                        <>
                            <form className={styles.formWrapper} onSubmit={handleSubmit}>
                                <FormSpy subscription={{ valid: true, pristine: true }} onChange={(formState) => {
                                    const { valid, pristine } = formState;
                                    setFormPristine(pristine)
                                    // formStepsValidityRef.current[UnderwritingSteps.company] = !state.valid;
                                    setStepValidity(DisbursementFormSteps.INVOICE_PRODUCTS, valid)
                                    setIsBtnEnabled(valid);
                                }} />
                                <div className={styles.innerRootContainer}>
                                    <div className={styles.formRootContainer}>
                                        <div className={styles.titleContainer}>
                                            <div className={styles.title}>
                                                Add Products From Your Invoice
                                            </div>
                                            <div className={styles.subTitle}>
                                                Select products from your sales channels. <br /> If they’re not listed, “Add” them.
                                            </div>
                                        </div>
                                        <div className={styles.selectProductRootContainer}>
                                            <AsyncSelectField value={formValues?.invoiceProducts} ipConfig={ipConfigs} onChange={(selectedOption, actionType) => {
                                                manipulateSelectOptions(form.change, form.mutators, selectedOption, actionType, formValues.invoiceProducts)
                                            }} />

                                            <div className={styles.dividerSection}>
                                                <hr />
                                                <div className={styles.dividerText}>OR</div>
                                                <hr />
                                            </div>
                                            <div className={styles.btnContainer}>
                                                <MeritoButton type='secondary-2' size='md2' onClick={() => {
                                                    setIsNewProductForm(true)
                                                }} icon={<AddIcon />} btnText="Add New Product" />
                                            </div>
                                        </div>

                                        <FieldArray name='invoiceProducts'>
                                            {({ fields }) => {
                                                return (
                                                    <>
                                                        {fields.length ?
                                                            <div className={styles.productListContainer}>
                                                                <div className={styles.title}>
                                                                    Added Products ({fields.length})
                                                                </div>
                                                                {fields.map((fieldName, fieldIndex) => {
                                                                    return (
                                                                        <>
                                                                            <InvoiceProductItem key={fieldName} fieldIndex={fieldIndex} fieldName={fieldName} ipConfigs={ipConfigs} />
                                                                            {fields.length - 1 != fieldIndex ? <div className={styles.separator}></div> : null}
                                                                        </>
                                                                    )
                                                                })}
                                                            </div>
                                                            :
                                                            <div className={styles.noProductColdState}>
                                                                <div className={styles.iconContainer}>
                                                                    <ShoppingBagIcon />
                                                                </div>
                                                                <div className={styles.coldText}>
                                                                    No Products Added!
                                                                </div>
                                                            </div>
                                                        }
                                                    </>
                                                )
                                            }}
                                        </FieldArray>
                                    </div>
                                    <OnChange name="totalAmount">
                                        {(values, previousValue) => {
                                            setTotalAmount(values)
                                        }}
                                    </OnChange>
                                    <NewProductForm isOpen={isNewProductForm} onClose={() => {
                                        setIsNewProductForm(false)
                                    }} handleAddNewProduct={(values) => {
                                        handleAddNewProduct(form.change, values, formValues.invoiceProducts)
                                    }} />
                                </div>
                            </form>
                        </>
                    )
                }}
            />
        </div>
    );
})

export default InvoiceProducts;